import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const FadeUp = ({ children, delay = 0, className = "", ...props }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 44 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
    {...props}
  >
    {children}
  </motion.div>
);

export const Chapter = ({ number, title }) => (
  <FadeUp className="mb-14 flex items-center gap-5 md:mb-20" data-testid={`chapter-${number}`}>
    <span className="font-spacemono text-xs text-[#F97316]">({number})</span>
    <span className="font-spacemono text-xs uppercase tracking-[0.35em] text-white/50">{title}</span>
    <span className="h-px flex-1 bg-white/10" />
  </FadeUp>
);
